module.exports = __webpack_public_path__ + "img/86.7da5cc9.png";